import { useCallback, useState } from 'react'
import { Button, Flex, Form, Skeleton, notification } from 'antd'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import {   mappingDataViewOnly } from '../components/utils'
import '../components/index.scss'
import FormPayee from '../components/formPayee'
import { getPayeeMatchParametersDetail } from 'src/app/shared/services/PayeeMatchParameters'


const ViewPayeeMatchParameters = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const [isFetched, setIsFetched] = useState(false)
  const [api, contextHolder] = notification.useNotification()

  const {
    control,
    setValue,
    formState: { errors },
  } = useForm<any>({
    mode: 'all',
    defaultValues: async () => await getPayee()
  })
  const handleCancel = () => {
    navigate(menuUrls.payeeMatchParameters)
  }
  const getPayee = useCallback(async () => {
    if (id) {
      const res = await getPayeeMatchParametersDetail(id)

      const formattedData = mappingDataViewOnly(res?.data)
      setIsFetched(true)
      return formattedData
    }
    navigate(menuUrls.bankUserSetup)
  }, [id, navigate])

  return (
    <>
      {contextHolder}
      <Form name='payee-match-parameter-form' className='payee-match-parameter-form-container' layout='vertical'>
        {isFetched ? <FormPayee control={control} errors={errors} isViewOnly={true} setValue={setValue}/> : <Skeleton />}

        <Flex className='button-group' justify='flex-end' gap={24}>
          <Button className='cancel-button' onClick={handleCancel}>
            {t('OverallFunctionality:back_btn')}
          </Button>
        </Flex>
      </Form>
    </>
  )
}

export default ViewPayeeMatchParameters
